import React from 'react'

export default function Copyright() {
  return (
    <div className='container'>
        <h3>Disclaimer for College Book</h3>
        <p>
        <b>College Book </b> respects the intellectual property rights of others and expects its users to do the same. 
        College Book will respond expeditiously to claims of copyright violation committed using the Collge Book 
        website.
        </p>
      <p>
      All the information on this website is published in good faith and for general information purpose only. 
      <b>College Book </b> does not make any warranties about the completeness, reliability and accuracy of this information. 
      Any action you take upon the information you find on this website (<a href='https://collegebooks.in'>https://collegebooks.in</a>), is strictly at your
       own risk. <a href="https://collegebooks.in">https://collegebooks.in</a> will not be liable for any losses and/or damages in connection with the use of
        Book's PDF.
      </p>
      <p>
      From <b>College Book </b>, you can visit other websites by following hyperlinks to such external sites for book's PDF. While we strive to provide only quality links to useful and ethical websites, we have no control over the content and nature of these sites. These links to other websites do not imply a recommendation for all the content found on these sites. Site owners and content may change without notice and may occur before we have the opportunity to remove a link which may have gone ‘bad’.

      </p>
      <p>
      On the download page you can find the remote file source url. Please contact them also to remove your copyrighted material. If you do not want  to index your PDF.

      </p>
      <p>
      Please be also aware that when you leave <b>College Book </b>, other sites may have different privacy policies and terms which are beyond our control. Please be sure to check the Privacy Policies of these sites as well as their “Terms of Service” before engaging in any business or uploading any information.

      </p>
    </div>
  )
}
